'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by zfc on 2017/5/13.
                                          */

// import {add, clearAdd} from 'redux/modules/attentionShop';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Header = require('../Header/Header');

var _Header2 = _interopRequireDefault(_Header);

var _reactRedux = require('react-redux');

var _experienceShopNewDetail = require('redux/modules/experienceShopNewDetail');

var _reduxAsyncConnect = require('redux-async-connect');

var _components = require('components');

var _reactRouterRedux = require('react-router-redux');

var _reactRouter = require('react-router');

var _background = require('redux/modules/background');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExperienceShopNewDetail = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: true,
  promise: function promise(_ref) {
    var _ref$store = _ref.store;
    var dispatch = _ref$store.dispatch;
    var getState = _ref$store.getState;
    var params = _ref.params;

    if (!(0, _experienceShopNewDetail.isLoaded)(getState())) {
      var promises = [];
      promises.push(dispatch((0, _experienceShopNewDetail.load)(params.experienceShopId)));
      promises.push(dispatch((0, _background.changeHeaderText)('体验店主页')));
      return _promise2.default.all(promises);
    }
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    data: state.experienceShopNewDetail.data
  };
}, {
  routerPush: _reactRouterRedux.push
}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ExperienceShopNewDetail, _Component);

  function ExperienceShopNewDetail() {
    (0, _classCallCheck3.default)(this, ExperienceShopNewDetail);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ExperienceShopNewDetail).call(this));

    _this.state = {
      headerActiveIndex: 0,
      isOwnerQRShow: false
    };
    return _this;
  }

  (0, _createClass3.default)(ExperienceShopNewDetail, [{
    key: 'onProductNavClick',
    value: function onProductNavClick(experienceId) {
      var routerPush = this.props.routerPush;

      if (routerPush) {
        routerPush('/experienceshopproductlist/' + experienceId);
      }
    }
  }, {
    key: 'onArticleClick',
    value: function onArticleClick() {
      this.setState({
        isGroupBuyingModalOpened: true
      });
    }
  }, {
    key: 'attentionExperienceShop',
    value: function attentionExperienceShop() {
      this.setState({
        isOwnerQRShow: true
      });
      /*    const {isOwnerQRShow} = this.state;
       if (isOwnerQRShow) {
       this.setState({
       isOwnerQRShow: false
       });
       } else {
       this.setState({
       isOwnerQRShow: true
       });
       } */
      // console.log('加入体验店会员');
    }
  }, {
    key: 'notAttentionExperienceShop',
    value: function notAttentionExperienceShop() {
      /*  const {isOwnerQRShow} = this.state;
       if (isOwnerQRShow) {
       this.setState({
       isOwnerQRShow: false
       });
       } else {
       this.setState({
       isOwnerQRShow: true
       });
       } */
      this.setState({
        isOwnerQRShow: false
      });
    }
  }, {
    key: 'activeChange',
    value: function activeChange(nextSection) {
      this.setState({
        headerActiveIndex: nextSection
      });
    }
  }, {
    key: 'closeQRModal',
    value: function closeQRModal() {
      this.setState({
        isOwnerQRShow: false
      });
    }
  }, {
    key: 'isContentToShow',
    value: function isContentToShow(item) {
      for (var _index = 0; _index < item.length; _index++) {
        if (item[_index].img) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state;
      var headerActiveIndex = _state.headerActiveIndex;
      var isOwnerQRShow = _state.isOwnerQRShow;
      var _props = this.props;
      var data = _props.data;
      var params = _props.params;

      var resultDiv = _react2.default.createElement('div', null);
      if (data) {
        (function () {
          var experienceShopDetailFirstPage = data.experienceShopDetailFirstPage;
          var experienceShopDetailIntroduction = data.experienceShopDetailIntroduction;
          var experienceShopDetailEvent = data.experienceShopDetailEvent;
          var experienceShopDetailArts = data.experienceShopDetailArts;
          var experienceShopDetailBasic = data.experienceShopDetailBasic;
          // let isAttentionModalOpened = false;

          var firstPageImgArray = [];
          if (experienceShopDetailFirstPage) {
            if (typeof experienceShopDetailFirstPage[0].img === 'string' && experienceShopDetailFirstPage[0].img !== '') {
              var _firstPageImgArray = experienceShopDetailFirstPage[0].img.split(',');
              _firstPageImgArray.forEach(function (item) {
                firstPageImgArray.push({ img: item });
              });
            }
          }
          var introductImgArray = [];
          if (experienceShopDetailIntroduction instanceof Array && experienceShopDetailIntroduction.length > 0) {
            if (typeof experienceShopDetailIntroduction[0].img === 'string' && experienceShopDetailIntroduction[0].img !== '') {
              var _introductImgArray = experienceShopDetailIntroduction[0].img.split(',');
              _introductImgArray.forEach(function (item) {
                introductImgArray.push({ img: item });
              });
            }
          }
          var eventImgArray = [];
          if (experienceShopDetailEvent instanceof Array && experienceShopDetailEvent.length > 0) {
            if (typeof experienceShopDetailEvent[0].img === 'string' && experienceShopDetailEvent[0].img !== '') {
              var _eventImgArray = experienceShopDetailEvent[0].img.split(',');
              _eventImgArray.forEach(function (item) {
                eventImgArray.push({ img: item });
              });
            }
          }

          var artImgArray = [];
          if (experienceShopDetailArts instanceof Array && experienceShopDetailArts.length > 0) {
            if (typeof experienceShopDetailArts[0].img === 'string' && experienceShopDetailArts[0].img !== '') {
              var _artImgArray = experienceShopDetailArts[0].img.split(',');
              _artImgArray.forEach(function (item) {
                artImgArray.push({ img: item });
              });
            }
          }
          var styles = require('../ProductDetails/ProductDetails.scss');
          var anchors = ['FirstPage'];
          var array = [{
            text: '首页',
            href: 'FirstPage',
            type: 'nav',
            icon: 'icon01'
          }];

          var contentDiv = [_react2.default.createElement(
            _components.FullPageSection,
            { key: '0', className: styles.goeasySection },
            _react2.default.createElement(
              'div',
              { className: styles.header },
              _react2.default.createElement(_Header2.default, null)
            ),
            firstPageImgArray instanceof Array && firstPageImgArray.length > 0 ? _react2.default.createElement(
              'div',
              { className: styles.firstFullPageItem },
              _react2.default.createElement(_components.ProductInfoFirstCarousel, { first: true, images: firstPageImgArray })
            ) : _react2.default.createElement(
              'div',
              { className: styles.firstFullPageItem, style: { paddingTop: 100, fontSize: 20, textAlign: 'center' } },
              '体验店资料维护中......'
            ),
            experienceShopDetailBasic && experienceShopDetailBasic[0].url ? _react2.default.createElement(
              _reactRouter.Link,
              { className: styles.quanjing, to: experienceShopDetailBasic[0].url, target: '_blank' },
              _react2.default.createElement('img', {
                src: 'http://tupian.goeasy.cn:9999/yipinwang/third/tyd_360.png' })
            ) : '',
            _react2.default.createElement('img', { onMouseOver: function onMouseOver() {
                return _this2.attentionExperienceShop();
              }, onMouseOut: function onMouseOut() {
                return _this2.notAttentionExperienceShop();
              },
              className: styles.experienceImg,
              src: 'http://tupian.goeasy.cn:9999/yipinwang/third/gztyd.png', alt: '' }),
            experienceShopDetailBasic ? _react2.default.createElement('img', { className: styles.qrImg + ' ' + (isOwnerQRShow ? styles.qrFadeIn : styles.qrFadeOut),
              src: experienceShopDetailBasic[0].qrcodeImg }) : ''
          )];

          if (introductImgArray instanceof Array && introductImgArray.length > 0) {
            anchors.push('ShopInfo');
            array.push({
              text: '简介',
              href: 'ShopInfo',
              type: 'nav',
              icon: 'icon20'
            });
            contentDiv.push(_react2.default.createElement(
              _components.FullPageSection,
              { key: '2', className: styles.goeasySection },
              _react2.default.createElement(_components.ProductInfoFirstCarousel, { images: introductImgArray })
            ));
          }

          if (eventImgArray instanceof Array && eventImgArray.length > 0) {
            anchors.push('ShopEvent');
            array.push({
              text: '活动',
              href: 'ShopEvent',
              type: 'nav',
              icon: 'icon18'
            });
            contentDiv.push(_react2.default.createElement(
              _components.FullPageSection,
              { key: '3', className: styles.goeasySection },
              _react2.default.createElement(_components.ProductInfoFirstCarousel, { images: eventImgArray })
            ));
          }

          if (artImgArray instanceof Array && artImgArray.length > 0 && _this2.isContentToShow(artImgArray)) {
            // console.log(artImgArray);
            anchors.push('ShopArts');
            array.push({
              text: '艺品',
              href: 'ShopArts',
              type: 'nav',
              icon: 'icon23'
            });
            contentDiv.push(_react2.default.createElement(
              _components.FullPageSection,
              { key: '4', className: styles.goeasySection },
              _react2.default.createElement(_components.ProductInfoFirstCarousel, { images: artImgArray }),
              _react2.default.createElement(
                'div',
                { className: styles.visitDiv },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/experienceshopproductlist/' + params.experienceShopId,
                    className: styles.visitBtn },
                  _react2.default.createElement('img', {
                    src: 'http://tupian.goeasy.cn:9999/yipinwang/third/more.png' })
                )
              )
            ));
          } else {
            array.push({
              text: '艺品',
              type: 'pop',
              icon: 'icon23',
              onClick: function onClick() {
                return _this2.onProductNavClick(params.experienceShopId);
              }
            });
          }

          var options = {
            sectionClassName: 'section',
            anchors: anchors,
            scrollBar: false,
            activeClass: styles.active,
            navigation: false,
            verticalAlign: false,
            sectionPaddingTop: '0',
            sectionPaddingLeft: '0',
            sectionPaddingRight: '0',
            sectionPaddingBottom: '0'
          };
          resultDiv = _react2.default.createElement(
            'div',
            { className: styles.component },
            headerActiveIndex === 0 && (artImgArray || introductImgArray || artImgArray) ? _react2.default.createElement(
              'a',
              { className: styles.nextIcon, href: '#shopInfoProducts' },
              _react2.default.createElement('img', {
                src: 'http://tupian.goeasy.cn:9999/yipinwang/xiala.png', alt: '' })
            ) : '',
            _react2.default.createElement(
              _components.FullPageHeader,
              null,
              _react2.default.createElement(_components.GoeasyFullPageHeader, { content: array, headerActiveIndex: headerActiveIndex })
            ),
            _react2.default.createElement(
              _components.FullPageSectionsContainer,
              (0, _extends3.default)({ activeChange: _this2.activeChange.bind(_this2),
                className: 'container' }, options),
              contentDiv
            )
          );
        })();
      }
      return resultDiv;
    }
  }]);
  return ExperienceShopNewDetail;
}(_react.Component), _class2.propTypes = {
  data: _react.PropTypes.object.isRequired,
  dispatch: _react.PropTypes.func,
  clearAddInfo: _react.PropTypes.func,
  location: _react.PropTypes.object,
  routerPush: _react.PropTypes.func,
  params: _react.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = ExperienceShopNewDetail;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ExperienceShopNewDetail/ExperienceShopNewDetail.js
 ** module id = 1474
 ** module chunks = 0
 **/